import axios from 'axios';

export const modulePayout = {
	state() {
		return {
			payout: null,
			commision: null,
			balance: null,
			showModalPayoutSuccess: false,
			//Loading
			payoutLoader: false,
		};
	},
	mutations: {
		setPayout(state, data) {
			state.payout = data;
		},
		setPayoutAmountString(state, data) {
			state.payout.payoutAmountString = data;
		},
		setPayoutAmount(state, data) {
			if (state.payout) {
				state.payout.payoutAmount = data;
			}
		},
		setSourceAccountId(state, data) {
			state.payout.sourceAccountId = data;
		},
		setDestinationAccountId(state, data) {
			state.payout.destinationAccountId = data;
		},
		setCommision(state, data) {
			state.commision = data;
		},
		setBalance(state, data) {
			state.balance = data;
		},
		setShowModalPayoutSuccess(state, data) {
			state.showModalPayoutSuccess = data;
		},
		//Loading
		setPayoutLoader(state, data) {
			state.payoutLoader = data;
		},
	},
	getters: {
		getPayout: (state) => state.payout,
		getCommision: (state) => state.commision,
		getBalance: (state) => state.balance,
		getShowModalPayoutSuccess: (state) => state.showModalPayoutSuccess,
		//Loading
		getPayoutLoader: (state) => state.payoutLoader,
	},
	actions: {
		postPayout({ state, commit, dispatch }) {
			commit('setGlobalErrorMessage', '');

			dispatch('newLogoutTime');
			return axios
				.post('Client/Payout', state.payout)
				.then((response) => {
					if (response.data.success) {
						commit('setShowModalPayoutSuccess', true);
						dispatch('fetchCommision');
						dispatch('fetchBalance');
						commit('setCurrentAmmount', '');
						commit('setDisabledPaymentButton', true);
						dispatch('fetchAccountList');
					} else {
						commit('setGlobalErrorMessage', response.data.message);
					}

					window.scroll({
						top: 0,
						left: 0,
						behavior: 'smooth',
					});
				})
				.catch(() => {
					commit('setGlobalErrorMessage', 'Wystąpił błąd');
				});
		},
		fetchPayout({ commit, dispatch }) {
			commit('setPayoutLoader', true);

			dispatch('newLogoutTime');
			axios
				.get('Client/Payout')
				.then((response) => {
					commit('setPayoutLoader', true);
					commit('setPayout', response.data);
				})
				.catch(() => {})
				.finally(() => {
					commit('setPayoutLoader', false);
				});
		},
		fetchCommision({ state, commit, dispatch }) {
			dispatch('newLogoutTime');
			if (state.payout) {
				var obj = {
					payoutAmount: state.payout.payoutAmount,
					destinationAccountId: state.payout.destinationAccountId,
				};
				axios
					.post('Client/CheckClientWithdrawalCommission', obj)
					.then((response) => {
						commit('setCommision', response.data.commission);
					});
			}
		},
		fetchBalance({ state, commit, dispatch }) {
			dispatch('newLogoutTime');

			if (!state.payout || state.payout.sourceAccountId == 0) {
				return;
			} else {
				axios
					.post(
						'Client/GetAccountInfo?sourceAccountId=' +
							state.payout.sourceAccountId,
						null
					)
					.then((response) => {
						commit('setBalance', response.data.balance);
					});
			}
		},
	},
};
